import {Component} from "@angular/core";
import {LocationEntityModel} from "../location-entity.model";
import {LocationSearchModel} from "../location-search.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-location-search-page",
    templateUrl: "./location-search-page.component.html",
    providers: [provideSearchModel(LocationSearchModel), provideEntityModel(LocationEntityModel)]
})
export class LocationSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
